import React, { useImperativeHandle, forwardRef, useState, useEffect, useRef, useCallback, useMemo } from "react";
import AppSimpleBar from "components/AppSimpleBar";
import { Button, Collapse, Dropdown, DropdownItem, DropdownMenu } from "reactstrap";
import classnames from "classnames";
import styled from 'styled-components';
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls";
import { Utils } from "helpers/utils";
import { bgcolor, maxHeight, minHeight } from "@mui/system";
import TextBox from "components/TextBox";
import Loader from "components/Loader";
import { WorkPlaceFilterSel, WorkPlaceCatFilter, WorkPlaceTagFilter, WpSliceData, WpEmpFilterType, TaskStatus, WpFilterTaskDueMode } from "../../../redux/workplace/wpTypes";
import { Const } from "const";
import { debounce, last, set } from "lodash";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { FormControlLabel, Switch } from "@mui/material";
import Select, { components } from 'react-select';
import { EmployeeOrg } from "types";
import { TABS, WpModes } from "../../../constants";

interface CtlEmpTypeProps {
  wpMode: WpModes;
  category: string;
  prefix: string;
  selectedValue: WpEmpFilterType;
  onClickOption: (cat: string, type: string, value: any) => void;
}

const CtlEmpType = ({ wpMode, category, prefix, onClickOption, selectedValue }: CtlEmpTypeProps) => {
  const radioName = `rdWpEmpFilterType${prefix}`;
  const radioId1 = radioName + '_1';
  const radioId2 = radioName + '_2';
  const radioId3 = radioName + '_3';
  const radioId4 = radioName + '_4';
  return (
    <>
      <div className="hand">
        <input type="radio" name={radioName} id={radioId1} checked={selectedValue === WpEmpFilterType.Poster}
          onChange={(e) => onClickOption(category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.Poster} />
        <label htmlFor={radioId1}>ผู้โพส</label>
      </div>
      <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
        <input type="radio" name={radioName} id={radioId2} checked={selectedValue === WpEmpFilterType.Tagged}
          onChange={(e) => onClickOption(category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.Tagged} />
        <label htmlFor={radioId2}>ถูก tag</label>
      </div>
      <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
        <input type="radio" name={radioName} id={radioId3} checked={selectedValue === WpEmpFilterType.InPost}
          onChange={(e) => onClickOption(category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.InPost} />
        <label htmlFor={radioId3}>เกี่ยวข้อง</label>
      </div>
      {wpMode == WpModes.Task && (
        <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
          <input type="radio" name={radioName} id={radioId4} checked={selectedValue === WpEmpFilterType.TaskOwner}
            onChange={(e) => onClickOption(category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.TaskOwner} />
          <label htmlFor={radioId4}>เจ้าของงาน</label>
        </div>
      )}
    </>
  );
}

interface WpCatItemProps {
  tagCat: WorkPlaceCatFilter;
  // category: string;
  // tags: WorkPlaceTagFilter[] | null;
  item: any;
  // onTagClick: (tagId: number, isFromSearch: boolean, icon: string, color: string, bgColor: string) => void;
  onTagSelect: (cat: string, tagSelected: WorkPlaceFilterSel[]) => void;
  onSearchTag: (cat: string, filter: string) => void;
  onClickTag: (cat: string, tagId: number, tagName: string) => void;
  onClickMuliSel: (cat: string) => void;
  onClickMatchedAll: (cat: string, matchedAll: boolean) => void;
  onClickOption: (cat: string, type: string, value: any) => void;
  onToggleCollapse: (cat: string, collapseAll: boolean | null) => void;
  tagFilter: string;
  tagFilterSelected: WorkPlaceTagFilter[];
  wpMode: WpModes;
  // onTagDel: (tagId: number) => void;
  // icon: string;
  filterUnRead: boolean;
}

const WpCatItem = ({ wpMode, tagCat, onSearchTag, onClickTag, onClickMuliSel, onClickMatchedAll, filterUnRead, item, onTagSelect, tagFilter, onClickOption, onToggleCollapse, tagFilterSelected }: WpCatItemProps) => {

  const isOpen = !tagCat.isCollapse;
  const [filter, setFilter] = useState<string>("");
  const toggleCollapse = () => {
    // setIsOpen((prev) => !prev);
    onToggleCollapse(tagCat.category, null);
  };

  const onSearchTagIn = () => {
    onSearchTag(tagCat.category, filter);
  }

  const tagCount = (tagCat.tags ?? []).filter(e => tagFilter === "" || Utils.IsMatchAny(e.name, tagFilter)).length;
  const visible = tagFilter === "" || tagCount > 0;
  const scrollStyle = useMemo(() => ({ maxHeight: "200px" }), []);
  const htmlId = wpMode == WpModes.Workplace ? "" : wpMode.toString();
  const filterTag = (tag: WorkPlaceTagFilter): boolean => {
    const unread = (filterUnRead == false) || (tag.unreadCount ?? 0) > 0;
    return unread && (tagFilter === "" || Utils.IsMatchAny(tag.name, tagFilter));
  }
  return (
    <div className="workplace-filter-cat" style={{ display: visible ? "" : "none" }} >
      <div className="d-flex justify-content-between workplace-filter-cat-head text-primary"  >
        <div className="d-flex justify-content-between align-items-center " style={{ flex: "1" }}>
          <i
            className={classnames("fab fa-blackberry me-2 hand", { "text-secondary": !tagCat.isMultiSel, "text-red": tagCat.isMultiSel })}
            onClick={(e) => onClickMuliSel(tagCat.category)}
          ></i>
          <span style={{ flex: "1",/*width: "100%"*/ }} className="hand " onClick={toggleCollapse}>
            <i className={classnames("", "me-1", item.faIcon)} ></i>
            {item.name}
          </span>
        </div>
        <div className="hand me-2" >
          <span
            className={classnames("badge hand " + (tagCat.tagMatchedAll ? " badge-primary text-danger " : " badge-warning text-primary "), {})}
            onClick={(e) => onClickMatchedAll(tagCat.category, !tagCat.tagMatchedAll)}
          >
            {tagCat.tagMatchedAll ? "AND" : "OR"}
          </span>

          &nbsp;&nbsp;&nbsp;
          <i onClick={toggleCollapse} className={classnames("pt-1", { "fas fa-angle-up": isOpen, "fas fa-angle-down": !isOpen })}></i>
        </div>
      </div>
      <Collapse
        isOpen={isOpen}
        className="accordion-collapse"
      >
        <div style={{ position: "relative" }}>
          {tagCat.isSearching && (<Loader />)}
          {tagCat.category === Const.WP_CAT_EMP && (
            <div className="ps-2 d-flex" style={{ gap: "5px" }}>
              <CtlEmpType wpMode={wpMode} category={tagCat.category} prefix={wpMode + "pane"} selectedValue={tagCat.empFilterType} onClickOption={onClickOption} />
            </div>
          )}
          {/* 20250612 hide textbox inside each category because use global filter instead */}
          {/* {tagCat.showSearchBox && (
            <div className="ms-1 me-2">
              <TextBox placeholder="ค้นหา" icon13css="fas fa-search" icon13small={true} style={{ padding: "2px" }} value={filter} onChange={(e) => setFilter(e.target.value)} onEnter13={onSearchTagIn} />
            </div>
          )} */}
          {/* <AppSimpleBar style={scrollStyle}> */}
          <div className="hide-scrollbar" style={{ maxHeight: "200px", overflow: "auto" }}>  {/*20251211 use app simple bar make its re-render and have some flicker with switching tab*/}
            <div className="ps-2 pt-1 pb-2">
              {/* all tag from database */}
              {/* {(tagCat.tags ?? []).filter(e => tagFilter === "" || Utils.IsMatchAny(e.name, tagFilter)).map((tag: any, index: number) => { */}
              {(tagCat.tags ?? []).filter(e => filterTag(e)).map((tag: any, index: number) => {
                const sel = (tagFilterSelected ?? []).some(t => t.tagId === tag.tagId);
                return (
                  (
                    <span key={tag.tagId}
                      className={classnames("wp-tag-filter-2 hand mb-2 hover", { "wp-tag-filter-sel": sel/*tag.selected*/ })}
                      onClick={() => onClickTag(tagCat.category, tag.tagId, tag.tagName)}
                      data-tg={`${tag.tagId}.${tag.tagKeyId}`}
                    >
                      <i className={"text-primary"}></i> {tag.name}
                      {tag.unreadCount > 0 && (<span className="wp-tag-filter-badge-unread">{tag.unreadCount > 99 ? '99+' : tag.unreadCount}</span>)}
                    </span>
                  )
                )
              })}
            </div>
          </div>
          {/* </AppSimpleBar> */}
        </div>
      </Collapse>
    </div>
  );
};

interface WorkPlaceFilterProps {
  onApplyFilter: () => void;
  allTags: WorkPlaceCatFilter[];
  onTagSelect: (cat: string, tagSelected: WorkPlaceFilterSel[]) => void;
  onSearchTag: (cat: string, filter: string) => void;
  onClickTag: (cat: string, tagId: number, tagName: string) => void;
  onClickTaskStatus: (taskStatus: TaskStatus) => void;
  taskStatusSelected: TaskStatus[];
  onClickMuliSel: (cat: string) => void;
  onClickMatchedAll: (cat: string, matchedAll: boolean) => void;
  filterUnRead: boolean;
  onFilterUnRead: (value: boolean) => void;
  filterNotClose: boolean;
  onFilterNotClose: (value: boolean) => void;
  onClickOption: (cat: string, type: string, value: any) => void;
  onToggleCollapse: (cat: string, collapseAll: boolean | null) => void;
  tagFilterSelected: WorkPlaceTagFilter[];
  wpMode: WpModes;
  filterTaskDueMode: WpFilterTaskDueMode,
  onFilterTaskDueMode: (value: WpFilterTaskDueMode) => void,
}



const WorkPlaceFilterX = (
  {
    onApplyFilter, onSearchTag, onClickTag, onTagSelect, onClickMuliSel, onClickMatchedAll, allTags, filterUnRead,
    onFilterUnRead, filterNotClose, onFilterNotClose, onClickOption, onToggleCollapse,
    tagFilterSelected, wpMode, onClickTaskStatus, taskStatusSelected,
    filterTaskDueMode, onFilterTaskDueMode

  }: WorkPlaceFilterProps) => {

  const [tagFilter, setTagFilter] = useState<string>("");
  const showCollapseAll = allTags.findIndex(prev => !prev.isCollapse) !== -1;
  const catShowSearch = allTags.filter(catx => catx.showSearchBox).map(x => x.category);
  const catShowSearchRef = useRef(catShowSearch);
  const delay = Utils.IsDesktop() ? 700 : 1500;

  useEffect(() => { catShowSearchRef.current = catShowSearch; }, [catShowSearch]);

  useEffect(() => {
    onMainFilterChangeDoSearch(tagFilter);
  }, [tagFilter]);

  const onMainFilterChangeDoSearch = useCallback(
    debounce((tagFilterDbc) => {
      catShowSearchRef.current.forEach(x => onSearchTag(x, tagFilterDbc));
    }, delay),
    [] // Dependencies are empty so it's only created once
  );

  const [filterMode, setFilterMode] = useState<"tag" | "emp">("tag");
  const [employeeOrg, setEmployeeOrg] = useState<EmployeeOrg[]>([]);
  const [ddlDivisionValues, setDdlDivisionValues] = useState<string[]>([]);
  const [ddlDepartmentValues, setDdlDepartmentValues] = useState<string[]>([]);
  const [empFilter, setEmpFilter] = useState<string>("");
  useEffect(() => {
    if (employeeOrg.length <= 0 && filterMode == "emp") {
      const api = new APIClient();
      api.fnPostForm(urls.LOAD_EMPLOYEE_ORG, {})
        .then(rs => setEmployeeOrg(rs))
        .catch(ex2 => Utils.HandleException(ex2, true));
    }
  }, [filterMode]);
  const ddlDivision = Array.from(
    new Map(
      employeeOrg
        .filter(ee => ee.divisionName)
        .map(t => [t.divisionName, { label: t.divisionName, value: t.divisionName }])
    ).values()
  ).sort((a: any, b: any) => a.label.localeCompare(b.label));

  const ddlDepartments = Array.from(
    new Map(
      employeeOrg
        .filter(ee =>
          ee.departmentName !== ""
          && (ddlDivisionValues.length <= 0 || ddlDivisionValues.includes(ee.divisionName))
          // && (() => { return ddlDivisionValues.length <= 0 || ddlDivisionValues.includes(ee.divisionName); })()
        ).map(t => [t.departmentName, { label: t.departmentName, value: t.departmentName }])
    ).values()
  ).sort((a: any, b: any) => a.label.localeCompare(b.label));

  const ddlEmployees = Array.from(
    new Map(
      employeeOrg
        .filter(ee =>
          ee.displayName2
          && (ddlDivisionValues.length <= 0 || ddlDivisionValues.includes(ee.divisionName))
          && (ddlDepartmentValues.length <= 0 || ddlDepartmentValues.includes(ee.departmentName))
          && (empFilter === "" || Utils.IsMatchAny(ee.displayName2, empFilter))
        ).map(t => [t.displayName2, { ...t }])
    ).values()
  ).sort((a: any, b: any) => a.displayName2.localeCompare(b.displayName2));


  const tagCatEmp: WorkPlaceCatFilter = allTags.find(t => t.category === Const.WP_CAT_EMP) ?? {
    category: "",
    faIcon: "",
    faColor: "",
    name: "",
    bgColor: "",
    tagCount: 0,
    showSearchBox: false,
    isSearching: null,
    isMultiSel: null,
    tagMatchedAll: false,
    empFilterType: WpEmpFilterType.Poster,
    tags: null,
    isCollapse: false,
  };

  const htmlId = wpMode == WpModes.Workplace ? "" : wpMode.toString();

  return (
    <div className="work-place-filter">
      <div className="work-place-filter-head m-1 mb-2 ">
        <div className="" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          {/* <h5 style={{ flex: "1", margin: "0px" }}>Filter</h5>
          <i className='fas fa-angle-double-left hand fz-15' onClick={onApplyFilter}></i>
          &nbsp; */}

          <div style={{ display: "flex", alignItems: "center", flex: 1 }} className="">
            {/* <h5 style={{ margin: "0px", marginRight: "8px" }}>Filter</h5> */}
            <div className="d-flex justify-content-between" style={{ marginRight: "10px", flex: 1 }}>
              <input
                type="text"
                placeholder="กรอง tag..."
                className="work-place-filter-text form-control form-control-inline"
                value={tagFilter}
                onChange={(e) => setTagFilter(e.target.value)}
                style={{ width: "100%" }}
                onFocus={(e) => setFilterMode("tag")}

              />
              {tagFilter && (<i className="fa fa-close fz-14 mt-1 hand" onClick={() => setTagFilter("")}></i>)}
            </div>
            <div className="">
              <button
                className={classnames("wp-btn-filter-emp", { "bg-warning": filterMode == "emp" })}
                title="กรองพนักงาน แบบเลือกจากโครงสร้างองค์กร"
                onClick={() => setFilterMode(filterMode === "emp" ? "tag" : "emp")}
              >
                <i className="fa fa-filter"></i>
                พนักงาน
              </button>
            </div>

          </div>
          <i
            className="fas fa-angle-double-left hand fz-15 ms-1"
            onClick={onApplyFilter}
          ></i>
        </div>
      </div>
      <div id="tagFilterByTag" className={classnames("", { "hide": filterMode !== "tag" })}>
        <div className="ps-2 " style={{ backgroundColor: "var(--bs-body-bg)" }}>
          <div className={"d-flex justify-content-between " + (wpMode == WpModes.Workplace ? "align-items-center" : "align-items-end")}>
            {/* left */}
            <div className="mt-1">
              <div className="no-wrap">
                <input type="checkbox" id={`chkFilterUnread${wpMode}`} checked={filterUnRead} onChange={(e) => onFilterUnRead(e.target.checked)} />&nbsp;<label htmlFor={`chkFilterUnread${wpMode}`}>ยังไม่อ่าน</label>
                {wpMode === WpModes.Workplace && (
                  <>
                    &nbsp;
                    <input type="checkbox" id={`chkFilterIsOpen${wpMode}`} checked={filterNotClose} onChange={(e) => onFilterNotClose(e.target.checked)} />&nbsp;<label htmlFor={`chkFilterIsOpen${wpMode}`}>ยังไม่ปิด</label>
                  </>
                )}

                {wpMode === WpModes.Task && (
                  <>
                    &nbsp;
                    <input type="checkbox" id={`chkTaskComingDue${wpMode}`} checked={filterTaskDueMode === WpFilterTaskDueMode.ComingDue} onChange={(e) => onFilterTaskDueMode(WpFilterTaskDueMode.ComingDue)} />&nbsp;<label htmlFor={`chkTaskComingDue${wpMode}`}>ใกล้กำหนด</label>
                    &nbsp;
                    <input type="checkbox" id={`chkTaskOverdDue${wpMode}`} checked={filterTaskDueMode === WpFilterTaskDueMode.OverdDue} onChange={(e) => onFilterTaskDueMode(WpFilterTaskDueMode.OverdDue)} />&nbsp;<label htmlFor={`chkTaskOverdDue${wpMode}`}>เลยกำหนด</label>
                  </>
                )}
              </div>

              {wpMode === WpModes.Task && (
                <div className="mt-1">
                  {Utils.GetTaskStatusForShow().map((eachItem, index) => (
                    // <span className="wp-tag-filter hand mb-2 hover">
                    <span
                      key={index}
                      className={"wp-tag-filter hand mb-2 hover badge-task-status-" + TaskStatus[eachItem].toLowerCase() + (taskStatusSelected.some(x => x == eachItem) ? " badge-task-status-sel" : "")}
                      onClick={(e) => onClickTaskStatus(eachItem)}
                    >
                      {Utils.GetTaskStatusIcon(eachItem)}{Utils.GetTaskStatusText(eachItem)}
                    </span>
                  ))}
                </div>
              )}
            </div>
            {/* right */}
            <div >
              <div className="text-center hand text-primary mt-1 mb-1"
                style={{ width: "28px" }} onClick={(e) => onToggleCollapse("", showCollapseAll)}>
                <i style={{}} className={classnames("fz-15 fas", { "fa-angle-double-up": showCollapseAll, "fa-angle-double-down": !showCollapseAll })}
                ></i>
              </div>
            </div>

          </div>
        </div>
        <AppSimpleBar className="work-place-filter-list ">
          <div id="wpTagCat" className="accordion-del accordion-flush-del">
            {allTags.map((data: WorkPlaceCatFilter, index: number) => {
              return (
                <WpCatItem
                  key={data.category} tagCat={data} item={data} onSearchTag={onSearchTag} onClickMuliSel={onClickMuliSel} onClickMatchedAll={onClickMatchedAll}
                  onClickTag={onClickTag} onTagSelect={onTagSelect} tagFilter={tagFilter} onClickOption={onClickOption} onToggleCollapse={onToggleCollapse}
                  tagFilterSelected={tagFilterSelected} wpMode={wpMode} filterUnRead={filterUnRead}
                />
              )
            })}
          </div>
        </AppSimpleBar>
      </div>
      <div id="tagFilterByEmp" className={classnames("", { "hide": filterMode !== "emp" })} style={{ backgroundColor: "var(--bs-body-bg)", height: "100vh" }}>
        <div className="ps-0" >
          <div className="ps-2 d-flex" style={{ gap: "5px" }}>

            <CtlEmpType wpMode={wpMode} category={tagCatEmp.category} prefix={wpMode + "hdr"} selectedValue={tagCatEmp.empFilterType} onClickOption={onClickOption} />

            {/* <div className="hand">
              <input type="radio" name={`rdWpEmpFilterType2${htmlId}`} id={`WpEmpFilterType21${htmlId}`} checked={tagCatEmp.empFilterType === WpEmpFilterType.Poster}
                onChange={(e) => onClickOption(tagCatEmp.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.Poster} />
              <label htmlFor={`WpEmpFilterType21${htmlId}`}>ผู้โพส</label>
            </div>
            <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
              <input type="radio" name={`rdWpEmpFilterType2${htmlId}`} id={`WpEmpFilterType22${htmlId}`} checked={tagCatEmp.empFilterType === WpEmpFilterType.Tagged}
                onChange={(e) => onClickOption(tagCatEmp.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.Tagged} />
              <label htmlFor={`WpEmpFilterType22${htmlId}`}>ถูก tag</label>
            </div>
            <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
              <input type="radio" name={`rdWpEmpFilterType2${htmlId}`} id={`WpEmpFilterType23${htmlId}`} checked={tagCatEmp.empFilterType === WpEmpFilterType.InPost}
                onChange={(e) => onClickOption(tagCatEmp.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.InPost} />
              <label htmlFor={`WpEmpFilterType23${htmlId}`}>เกี่ยวข้อง</label>
            </div>
            {wpMode == WpModes.Task && (
              <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
                <input type="radio" name={`rdWpEmpFilterType2${htmlId}`} id={`WpEmpFilterType24${htmlId}`} checked={tagCatEmp.empFilterType === WpEmpFilterType.TaskOwner}
                  onChange={(e) => onClickOption(tagCatEmp.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.TaskOwner} />
                <label htmlFor={`WpEmpFilterType24${htmlId}`}>เจ้าของงาน</label>
              </div>
            )} */}

          </div>

          <Select
            placeholder="เลือกหน่วยงาน"
            options={ddlDivision as any[]}
            styles={Utils.GetThemeForReactSelect()}
            // onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
            onChange={(e: any) => setDdlDivisionValues(e ? [e.value] : [])}
            // value={item.division ? ddlDivison?.find(t => t.value === item.division) : null}
            isClearable={true}
          // isMulti={true}
          ></Select>

          <Select
            placeholder="เลือกแผนก"
            options={ddlDepartments as any[]}
            styles={Utils.GetThemeForReactSelect()}
            // onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
            onChange={(e: any) => setDdlDepartmentValues(e ? [e.value] : [])}
            // value={item.division ? ddlDivison?.find(t => t.value === item.division) : null}
            isClearable={true}
          // isMulti={true}
          ></Select>

          <TextBox placeholder="กรองพนักงาน" className="form-control wp-filter-emp-textbox" value={empFilter} onChange={(e) => setEmpFilter(e.target.value)} />

          <AppSimpleBar className="wp-filter-emp-ctn">
            {ddlEmployees.map((x, index) => {
              const sel = tagFilterSelected.some(t => t.tagId === x.tagId);
              return (
                <div key={index}
                  className={classnames("hover hand", {
                    "bg-primary": sel,
                    "text-warning": sel
                  })}

                  onClick={() => onClickTag(Const.WP_CAT_EMP_FROM_BROWSE, x.tagId ?? -1, x.displayName2)}
                >
                  {x.displayName2}
                </div>
              )
            })}
          </AppSimpleBar>
        </div>
      </div>
    </div>
  );
};

//export default WorkPlaceFilter;
const WorkPlaceFilter = React.memo(WorkPlaceFilterX);
// WorkPlaceFilter.whyDidYouRender = true;
export default WorkPlaceFilter;

